<template>
  <GenerateDialog
    :isOpen="isOpen"
    :isLoading="isLoading"
    @close="close"
    title="Generate Invoices"
    :onSubmit="handleSubmit"
    isInvoice
  />
</template>

<script>
import { GENERATE_INVOICES } from "@/store/modules/invoices/action-types";
import { createNamespacedHelpers } from "vuex";
import { INVOICE_NAMESPACE } from "@/store/modules/invoices";
import GenerateDialog from "@/views/finance/components/Generate/components/GenerateDialog";

const { mapActions } = createNamespacedHelpers(INVOICE_NAMESPACE);

export default {
  name: "GenerateInvoices",
  components: { GenerateDialog },
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions({
      generateInvoices: GENERATE_INVOICES
    }),
    close() {
      this.$emit("close");
    },
    async handleSubmit(formValue) {
      this.isLoading = true;
      try {
        await this.generateInvoices(formValue);
        this.close();
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
